<template>
  <div>
    <v-app-bar
        color="#031626"
        dark
        rounded
        elevation="24"
    >
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      <v-row class="navbar-top-row">
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 7 : 8" class="mt-4">
          <!--            <v-row>-->
          <!--              <v-col cols="8">-->
          <!--                <v-icon v-if="!notifications.length">mdi-account</v-icon>-->
          <!--                <v-menu v-else offset-y min-width="30vw" max-width="50vw">-->
          <!--                  <template v-slot:activator="{ on, attrs }">-->
          <!--                    <v-btn-->
          <!--                        @click="getNotifications()"-->
          <!--                        color="error"-->
          <!--                        class="pa-0"-->
          <!--                        style="font-size: 1vw!important"-->
          <!--                        fab-->
          <!--                        x-small-->
          <!--                        v-bind="attrs"-->
          <!--                        v-on="on"-->
          <!--                    >-->
          <!--                      {{ notifications.length }}-->
          <!--                    </v-btn>-->
          <!--                  </template>-->
          <!--                  <v-list>-->
          <!--                    <v-list-item-->
          <!--                        v-for="(notification, index) in notifications"-->
          <!--                        :key="index"-->
          <!--                    >-->
          <!--                      <v-row @click="showNotification(notification)" style="cursor: pointer;">-->
          <!--                        <v-col cols="2">-->
          <!--                          <v-icon>mdi-{{ notification.icon }}</v-icon>-->
          <!--                        </v-col>-->
          <!--                        <v-col cols="10">-->
          <!--                          {{ notification.title }} از {{ notification.sender_name }}-->
          <!--                        </v-col>-->
          <!--                        <v-col cols="12">-->
          <!--                          <v-divider></v-divider>-->
          <!--                        </v-col>-->
          <!--                      </v-row>-->
          <!--                    </v-list-item>-->
          <!--                  </v-list>-->
          <!--                </v-menu>-->
          <!--                {{ user.name }}-->
          <!--              </v-col>-->
          <!--            </v-row>-->
        </v-col>
        <v-col v-if="!$vuetify.breakpoint.smAndDown" cols="1" class="mt-2 text-left">
          <v-icon color="#fdf4d5">mdi-message-outline</v-icon>
        </v-col>
        <v-col v-if="!$vuetify.breakpoint.smAndDown" cols="1" class="mt-2 text-left">
          <v-icon color="#fdf4d5">mdi-format-list-checks</v-icon>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 3 : 1" class="mt-2 text-left">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn fab v-bind="attrs" text style="margin-top: -17px!important"
                     v-on="on">
                <v-badge v-if="notifications.length" :content="notifications.length" color="error">
                  <v-icon size="x-large" class="color-green custom-animation-navbar-middle">mdi-bell-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <v-list>
              <v-list-item style="cursor: pointer!important;" v-for="notification in notifications"
                           :key="'notif'+notification.id">
                <v-list-item-title @click="openNotification(notification.id)">{{ notification.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 2 : 1" class="mt-2 text-left">
          <v-icon @click="logout()" color="red">mdi-logout</v-icon>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-navigation-drawer
        :width="drawerWidth"
        v-model="drawer"
        right
        absolute
        temporary
        color="#001a33"
    >
      <v-list
          nav
          dense
      >
        <v-list-item-group
            v-model="group"
            active-class="active-tab"
        >
          <v-list-item class="item-navbar mt-16" two-line to="/dashboard">
            <v-list-item-icon>
              <v-icon color="#fdf4d5" large class="mt-7">mdi-account-details-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="item-navbar-text">داشبورد</v-list-item-title>
          </v-list-item>

          <v-list-item v-if="userType === 'instructor'" class="item-navbar" two-line to="/profile">
            <v-list-item-icon>
              <v-icon color="#fdf4d5" large class="mt-7">mdi-account-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="item-navbar-text">ویرایش پروفایل</v-list-item-title>
          </v-list-item>

          <v-list-item class="item-navbar" two-line to="/activities/index">
            <v-list-item-icon>
              <v-icon color="#fdf4d5" large class="mt-7">mdi-history</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="item-navbar-text">فعالیت‌ها</v-list-item-title>
          </v-list-item>

          <v-list-group
              v-if="userType !== 'instructor'"
              no-action
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon color="#fdf4d5" large class="mt-2">mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content
              >
                <v-list-item-title
                    class="item-navbar-text pr-0">
                  کاربران
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item to="/students/index"
            >
              <v-list-item-title class="item-navbar-sub-text">هنرجویان</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-account-group-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/teachers/index"
            >
              <v-list-item-title class="item-navbar-sub-text">اساتید</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-account-multiple-check</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>

          <v-list-item
              v-if="userType !== 'instructor'"
              class="item-navbar" two-line to="/permission-and-role/role/index"
          >
            <v-list-item-icon>
              <v-icon color="#fdf4d5" large class="mt-7">mdi-key-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="item-navbar-text">دسترسی</v-list-item-title>
          </v-list-item>

          <v-list-item
              v-if="userType !== 'instructor'"
              class="item-navbar" two-line to="/school/index"
          >
            <v-list-item-icon>
              <v-icon color="#fdf4d5" large class="mt-7">mdi-town-hall</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="item-navbar-text">مدیریت آموزشگاه ها</v-list-item-title>
          </v-list-item>




          <v-list-group
              v-if="userType !== 'instructor'"
              no-action
              color="white"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon color="#fdf4d5" large class="mt-2">mdi-message</v-icon>
              </v-list-item-icon>
              <v-list-item-content
              >
                <v-list-item-title
                    class="item-navbar-text pr-0">
                  مدیریت پیام ها
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item to="/messages/create"
            >
              <v-list-item-title class="item-navbar-sub-text"> ارسال پیام</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-message-plus-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/messages/index"
            >
              <v-list-item-title class="item-navbar-sub-text"> مشاهده پیام ها</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-forum</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/tickets/index"
            >
              <v-list-item-title class="item-navbar-sub-text"> تیکت ها</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-message-alert-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>

          </v-list-group>

          <v-list-group
              no-action
              color="white"
              v-if="userType !== 'instructor'"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon color="#fdf4d5" large class="mt-2">mdi-school-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content
              >
                <v-list-item-title
                    class="item-navbar-text pr-0">
                  دوره ها
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item to="/courses/index"
            >
              <v-list-item-title class="item-navbar-sub-text">مدیریت دوره ها</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-school-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item to="/courses/create"
            >
              <v-list-item-title class="item-navbar-sub-text">ساخت دوره</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-layers-plus</v-icon>
              </v-list-item-icon>
            </v-list-item>

          </v-list-group>
          <v-list-group
              no-action
              color="white"
              v-if="userType !== 'instructor'"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon color="#fdf4d5" large class="mt-2">mdi-newspaper-variant-multiple-outline
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content
              >
                <v-list-item-title
                    class="item-navbar-text pr-0">
                  درس ها
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item to="/items/index"
            >
              <v-list-item-title class="item-navbar-sub-text">مدیریت درس ها</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-school-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item to="/items/create"
            >
              <v-list-item-title class="item-navbar-sub-text">ساخت درس جدید</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-layers-plus</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/dictation/index"
            >
              <v-list-item-title class="item-navbar-sub-text">مدیریت دیکته ها</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-music-accidental-double-flat</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/dictation/create"
            >
              <v-list-item-title class="item-navbar-sub-text">ساخت دیکته</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-music-clef-treble</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/dictation/alphabet/index"
            >
              <v-list-item-title class="item-navbar-sub-text">مدیریت الفبا</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-alphabet-latin</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/dictation/alphabet/create"
            >
              <v-list-item-title class="item-navbar-sub-text">ساخت الفبا</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-alpha</v-icon>
              </v-list-item-icon>
            </v-list-item>

          </v-list-group>
          <!--                    <v-list-group-->
          <!--                            no-action-->
          <!--                            color="white"-->
          <!--                    >-->
          <!--                        <template v-slot:activator>-->
          <!--                            <v-list-item-icon>-->
          <!--                                <v-icon color="#fdf4d5" large class="mt-2">mdi-multimedia</v-icon>-->
          <!--                            </v-list-item-icon>-->
          <!--                            <v-list-item-content-->
          <!--                            >-->
          <!--                                <v-list-item-title-->
          <!--                                        class="item-navbar-text pr-0">-->
          <!--                                    فایل های درسی-->
          <!--                                </v-list-item-title>-->
          <!--                            </v-list-item-content>-->
          <!--                        </template>-->
          <!--                        <v-list-item to="/item-files/index"-->
          <!--                        >-->
          <!--                            <v-list-item-title class="item-navbar-sub-text">مدیریت فایل های درسی</v-list-item-title>-->

          <!--                            <v-list-item-icon>-->
          <!--                                <v-icon color="#fdf4d5">mdi-file-multiple</v-icon>-->
          <!--                            </v-list-item-icon>-->
          <!--                        </v-list-item>-->
          <!--                        <v-list-item to="/item-files/create"-->
          <!--                        >-->
          <!--                            <v-list-item-title class="item-navbar-sub-text">ساخت فایل درسی جدید</v-list-item-title>-->

          <!--                            <v-list-item-icon>-->
          <!--                                <v-icon color="#fdf4d5">mdi-file-image-plus-outline</v-icon>-->
          <!--                            </v-list-item-icon>-->
          <!--                        </v-list-item>-->

          <!--                    </v-list-group>-->
          <!--                    <v-list-item-->
          <!--                            class="item-navbar" two-line to="/cover/index">-->
          <!--                        <v-list-item-icon>-->
          <!--                            <v-icon color="#fdf4d5" large class="mt-7">mdi-panorama-variant-outline</v-icon>-->
          <!--                        </v-list-item-icon>-->
          <!--                        <v-list-item-title class="item-navbar-text">مدیریت کاور ها</v-list-item-title>-->
          <!--                    </v-list-item>-->
          <v-list-group
              no-action
              color="white"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon color="#fdf4d5" large class="mt-2">mdi-human-male-board</v-icon>
              </v-list-item-icon>
              <v-list-item-content
              >
                <v-list-item-title
                    class="item-navbar-text pr-0">
                  کلاس ها
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item to="/classes/create" v-if="userType !== 'instructor'"
            >
              <v-list-item-title class="item-navbar-sub-text">افزودن کلاس</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-account-multiple-plus-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/classes/index" v-if="userType !== 'instructor'"
            >
              <v-list-item-title class="item-navbar-sub-text">لیست کلاس ها</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-human-male-board</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/classes/my/index"
            >
              <v-list-item-title class="item-navbar-sub-text"> کلاس های من</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-calendar-multiselect</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/classes/online/index"
            >
              <v-list-item-title class="item-navbar-sub-text"> مدیریت جلسه آنلاین خصوصی</v-list-item-title>
              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-web</v-icon>
              </v-list-item-icon>
            </v-list-item>

          </v-list-group>


          <v-list-group
              no-action
              color="white"
              v-if="userType !== 'instructor'"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon color="#fdf4d5" large class="mt-2">mdi-chart-bar-stacked</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="item-navbar-text pr-0">مدیریت ارزیابی</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item to="/activity-tags/index">
              <v-list-item-title class="item-navbar-sub-text">امتیاز فعالیت ها</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-tag-multiple-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/effort-calendar">
              <v-list-item-title class="item-navbar-sub-text">تقویم تلاش</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-calendar-clock</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>


          <v-list-group
              no-action
              color="white"
              v-if="userType !== 'instructor'"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon color="#fdf4d5" large class="mt-2">mdi-currency-usd</v-icon>
              </v-list-item-icon>
              <v-list-item-content
              >
                <v-list-item-title
                    class="item-navbar-text pr-0">
                  مالی
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item to="/transaction/index"
            >
              <v-list-item-title class="item-navbar-sub-text">لیست تراکنش ها</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-cash-multiple</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/orders"
            >
              <v-list-item-title class="item-navbar-sub-text">لیست خرید دوره ها</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-bookshelf</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/transaction/analysis"
            >
              <v-list-item-title class="item-navbar-sub-text">آنالیز مالی</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-cash-register</v-icon>
              </v-list-item-icon>
            </v-list-item>

          </v-list-group>

          <v-list-group
              no-action
              color="white"
              v-if="userType !== 'instructor'"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon color="#fdf4d5" large class="mt-2">mdi-folder-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content
              >
                <v-list-item-title
                    class="item-navbar-text pr-0">
                  مدیریت فایل ها
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item to="/file-manager/index"
            >
              <v-list-item-title class="item-navbar-sub-text">مشاهده فایل ها</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-folder-table-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/file-manager/store"
            >
              <v-list-item-title class="item-navbar-sub-text">بارگزاری فایل جدید</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-folder-plus</v-icon>
              </v-list-item-icon>
            </v-list-item>

          </v-list-group>

          <v-list-group
              no-action
              color="white"
              v-if="userType !== 'instructor'"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon color="#fdf4d5" large class="mt-2">mdi-robot-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content
              >
                <v-list-item-title
                    class="item-navbar-text pr-0">
                  یادگیری ماشین
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item to="/machine-learning/tuning"
            >
              <v-list-item-title class="item-navbar-sub-text">تنظیم ماشین</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-tune-variant</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/machine-learning/music-piece-builder"
            >
              <v-list-item-title class="item-navbar-sub-text">ساخت قطعه موسیقی</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-music-circle-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>

          </v-list-group>


          <v-list-item
              v-if="userType !== 'instructor'"
              class="item-navbar" two-line to="/hints">
            <v-list-item-icon>
              <v-icon color="#fdf4d5" large class="mt-7">mdi-information-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="item-navbar-text">راهنما</v-list-item-title>
          </v-list-item>

          <v-list-item
              v-if="userType !== 'instructor'"
              class="item-navbar" two-line to="/subscription/index">
            <v-list-item-icon>
              <v-icon color="#fdf4d5" large>mdi-playlist-check</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="item-navbar-text">مدیریت اشتراک ها</v-list-item-title>
          </v-list-item>

          <v-list-item
              v-if="userType !== 'instructor'"
              class="item-navbar" two-line to="/notifications/index">
            <v-list-item-icon>
              <v-badge v-if="notifications.length" :content="notifications.length" color="error">
                <v-icon color="#fdf4d5" large>mdi-information</v-icon>
              </v-badge>
              <v-icon v-else color="#fdf4d5" large>mdi-information</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="item-navbar-text">اعلان ها</v-list-item-title>
          </v-list-item>


          <v-list-item
              v-if="userType !== 'instructor'"
              class="item-navbar" two-line to="/sms/index">
            <v-list-item-icon>
              <v-icon color="#fdf4d5" large class="mt-4">mdi-mail</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="item-navbar-text">پنل پیامکی</v-list-item-title>
          </v-list-item>


          <v-list-item
              v-if="userType !== 'instructor'"
              class="item-navbar" two-line to="/otp/index">
            <v-list-item-icon>
              <v-icon color="#fdf4d5" large class="mt-4">mdi-location-enter</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="item-navbar-text">گزارش ورود</v-list-item-title>
          </v-list-item>

          <v-list-item
              class="item-navbar" two-line to="/notifications/my">
            <v-list-item-icon>
              <v-badge v-if="notifications.length" :content="notifications.length" color="error">
                <v-icon color="#fdf4d5" large>mdi-information-outline</v-icon>
              </v-badge>
              <v-icon v-else color="#fdf4d5" large>mdi-information</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="item-navbar-text">اعلان های من</v-list-item-title>
          </v-list-item>




          <v-list-group
              no-action
              color="white"
              v-if="userType !== 'instructor'"
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon color="#fdf4d5" large class="mt-2">mdi-tune-vertical</v-icon>
              </v-list-item-icon>
              <v-list-item-content
              >
                <v-list-item-title
                    class="item-navbar-text pr-0">
                  تنظیمات
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item to="/setting/category/index"
            >
              <v-list-item-title class="item-navbar-sub-text">دسته بندی ها</v-list-item-title>

              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-sitemap-outline</v-icon>
              </v-list-item-icon>
            </v-list-item>

            <v-list-item to="/setting/system/index"
            >
              <v-list-item-title class="item-navbar-sub-text">تنظیمات سیستم</v-list-item-title>
              <v-list-item-icon>
                <v-icon color="#fdf4d5">mdi-tune-vertical</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>

          <v-list-item
              v-if="userType !== 'instructor'"
              class="item-navbar" two-line to="/logs/index"
          >
            <v-list-item-icon>
              <v-icon color="error" large class="mt-7">mdi-information</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="item-navbar-text">Logs</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="userType !== 'instructor'" class="item-navbar" two-line to="/social-network">
            <v-list-item-icon><v-icon color="#fdf4d5" large class="mt-7">mdi-account-group-outline</v-icon></v-list-item-icon>
            <v-list-item-title class="item-navbar-text">شبکه اجتماعی</v-list-item-title>
          </v-list-item>
          <div class="mt-16 pl-16 text-center">
            <v-icon @click="logout()" color="error" x-large>mdi-logout</v-icon>
          </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-dialog v-if="notification" v-model="showSingleNotificationDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-card-actions>
          <v-icon color="error" @click="showSingleNotificationDialog = false">mdi-close</v-icon>
        </v-card-actions>
        <v-row class="ma-0">
          <v-col cols="12">
            {{ notification.title }}
          </v-col>
          <v-col cols="12">
            {{ notification.content }}
          </v-col>
          <v-col cols="12">
            {{ notification.created_at_fa }}
          </v-col>
          <v-col cols="6">
            <v-btn color="warning" @click="openNotificationPage()">
              برو به صفحه مورد نظر
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" @click="showSingleNotificationDialog=false">
              بستن
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: ['notifications'],
  data() {
    return {
      drawer: true,
      group: null,
      messageCount: 0,
      showSingleNotificationDialog: false,
      notification: [],
      userType : null
    }
  },
  mounted() {
    this.userType = this.$cookies.get('userType')
    this.initialListenWs()
  },
  methods: {
    openNotification(notificationId) {
      let url = '/instructor/notification/get/' + notificationId
      window.axios.get(url).then((res) => {
        this.notification = res.data.data
        this.showSingleNotificationDialog = true
      })
    },
    openNotificationPage() {
      this.showSingleNotificationDialog = false
      this.$router.push(this.notification.url)
      window.location.reload()
    },
    logout() {
      this.$cookies.remove('token')
      this.$router.go(0)
    },
    listenWs(type) {
      if (type === 'immediately') {
        this.$store.state.Echo.private('send.message.' + this.$store.state.user.id)
            .listen('SendMessage', (e) => {
              console.log(e)
              this.messageCount++
            })
      } else {
        let self = this
        window.setTimeout(function () {
          self.$store.state.Echo.private('send.message.' + self.$store.state.user.id)
              .listen('SendMessage', (e) => {
                console.log(e)
                self.messageCount++
              })
        }, 3000)
      }
    },
    initialListenWs() {
      if (!this.$store.state.user) {
        return
      }
      if (!this.$store.state.loadingEcho) {
        this.listenWs('immediately')
      } else {
        this.listenWs('wait')
      }
    },
  }
  ,
  computed: {
    drawerWidth() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return Math.max(window.innerWidth - 24, 280)
      }
      return '17vw'
    }
  }
}
</script>

<style>
.item-navbar-text {
  color: #fdf4d5 !important;
  font-size: 20px !important;
  padding: 10px !important;
}

.mdi-chevron-down {
  color: #fdf4d5 !important;
}

.item-navbar-sub-text {
  color: #fdf4d5 !important;
  font-size: 13px !important;
  padding: 10px !important;
}

>>> .v-icon .v-icon {
  color: #fdf4d5
}

@media (max-width: 960px) {
  .navbar-top-row {
    align-items: center;
  }

  .item-navbar-text {
    font-size: 16px !important;
    padding: 8px !important;
  }

  .item-navbar-sub-text {
    font-size: 12px !important;
    padding: 8px !important;
  }
}
</style>
